import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DataCompletenessState } from "./dataCompletenessTypes";
import dayjs from "dayjs";

const initialState: DataCompletenessState = {
  selectedStart: dayjs().add(-7, "days").toISOString(),
  selectedEnd: new Date().toISOString(),
};

const dataCompletenessSlice = createSlice({
  name: "dataCompletenessSlice",
  initialState,
  reducers: {
    setSelectedStart: (state, action: PayloadAction<Date>) => {
      state.selectedStart = action.payload.toISOString();
    },
    setSelectedEnd: (state, action: PayloadAction<Date>) => {
      state.selectedEnd = action.payload.toISOString();
    },
  },
});
export const { setSelectedStart, setSelectedEnd } = dataCompletenessSlice.actions;

export default dataCompletenessSlice.reducer;
